import styled from 'styled-components';
import { COLOR_CV_6, COLOR_WHITE } from 'constants/colors';
import { Avatar, Button } from 'UI';

export const CardContainer = styled(Button)`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(3, auto);
  justify-items: center;
  grid-gap: 1rem;
  background-color: ${COLOR_WHITE};
  padding: 2.125rem;
  min-width: 262px;
  width: 100%;
  border-radius: 5px;

  &:hover {
    background-color: ${COLOR_WHITE};
  }
`;

export const StyledAvatar = styled(Avatar)`
  & .ant-avatar-string {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    fill: ${COLOR_CV_6};
  }
`;

export const TitleContainer = styled.div`
  display: block;
  font-size: 1.25rem;
  font-weight: 700;
  color: ${COLOR_CV_6};
  line-height: 1.75rem;
`;
